var ProductTypeEnum;
(function (ProductTypeEnum) {
    ProductTypeEnum["fridge"] = "Heladera";
    ProductTypeEnum["tv"] = "Televisor";
    ProductTypeEnum["washingMachine"] = "Lavarropas";
    ProductTypeEnum["other"] = "Otro";
})(ProductTypeEnum || (ProductTypeEnum = {}));
export default ProductTypeEnum;
